import client from './client'

const saveForLater = (requestId) => client.post(`/requests/${requestId}/saveForLater`)

const complete = (requestId) => client.post(`/requests/${requestId}/complete`)

export default {
    saveForLater,
    complete
}